import { useState, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useQuery } from '@apollo/client'
import { isEmpty } from 'lodash'

import { Autocomplete } from 'components/v2/Autocomplete'
import { typeMessages } from 'features/Inventories/components/Type/messages'
import { GET_INVENTORIES_AUTOCOMPLETE } from 'resolvers/inventories'
import { safeFormatMessage } from 'utils/intl'

const messages = defineMessages({
  error: {
    id: 'spanish.inventories.autocomplete.error',
    defaultMessage: 'Hubo un error al cargar las ubicaciones'
  },
  empty: {
    id: 'spanish.inventories.autocomplete.empty',
    defaultMessage: 'No se encontraron ubicaciones'
  }
})

export const getInventoryLabel = (inventory: TSFixMe, intl: TSFixMe): TSFixMe => {
  if (inventory && inventory.id) {
    return `${inventory.name} (${safeFormatMessage({ intl, messages: typeMessages, key: inventory.type })})`
  }

  return ''
}

export const InventoryAutocomplete = ({ companyId, types, excludedInventories = [], ...props }: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [pattern, setPattern] = useState('')
  const { data, loading, error, refetch } = useQuery(GET_INVENTORIES_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      companyId,
      types
    }
  })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  let inventories = (data && data.inventoriesAutocomplete) || []

  if (!isEmpty(excludedInventories)) {
    inventories = inventories.filter(({ id }: TSFixMe): TSFixMe => !excludedInventories.includes(id))
  }

  const shownItems = inventories.filter((inventory: TSFixMe): TSFixMe => {
    return getInventoryLabel(inventory, intl).toLowerCase().indexOf(pattern.toLowerCase()) > -1
  })

  const handleChange = (inventory: TSFixMe, { inputValue = '' } = {}): TSFixMe => {
    setPattern(inputValue)

    if (!isEmpty(inventory)) {
      props.onChange(inventory)
    } else {
      props.onChange({
        id: '',
        name: ''
      })
    }
  }

  return (
    <Autocomplete
      {...props}
      items={shownItems}
      getItemLabel={(inventory): TSFixMe => getInventoryLabel(inventory, intl)}
      loading={loading}
      error={error}
      errorMessage={intl.formatMessage(messages.error)}
      emptyMessage={intl.formatMessage(messages.empty)}
      onChange={handleChange}
    />
  )
}
